(function () {
  // Mets ici les URLs des images DE, dans le même ordre que la galerie produit.
  // Exemple: si tu veux changer seulement la 2e image, tu mets null pour la 1ere, puis l'URL pour la 2e.
  const DE_IMAGES = [
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/Creatives_statiques_-_Champife_1.png?v=1767706846", // 1ère image
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/mix_champi_de.png?v=1767375298", // 2e image (celle que tu veux changer)
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/delicieux_cafe_de.png?v=1767378781", // 3ème image
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/rapide_de.png?v=1767379089",
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/valeur_nutritionel_de.png?v=1767379530",
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/energie_sans_crash_de.png?v=1767379722",
    "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/retrouve_ton_bienetre_de.png?v=1767379829",
  ];

  function getMainGalleryImages() {
    // Galerie principale (Dawn & thèmes proches)
    const container =
      document.querySelector(".product__media-list") ||
      document.querySelector(".product__media-wrapper") ||
      document;

    // On prend les images visibles de la galerie
    const imgs = Array.from(container.querySelectorAll(".product__media img"));

    // On enlève les doublons (Shopify peut dupliquer via modals/zoom)
    const seen = new Set();
    const unique = [];
    for (const img of imgs) {
      const key = img.getAttribute("src") || img.currentSrc || "";
      if (!key) continue;
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(img);
    }
    return unique;
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : "";
  }

  function isGerman() {
    // Weglot API si dispo
    if (window.Weglot) {
      try {
        if (typeof window.Weglot.getCurrentLang === "function") {
          return window.Weglot.getCurrentLang() === "de";
        }
        if (window.Weglot.currentLang) return window.Weglot.currentLang === "de";
      } catch (e) {}
    }

    // URL (souvent /de/ ou ?lang=de)
    const path = location.pathname.toLowerCase();
    const search = location.search.toLowerCase();
    if (path === "/de" || path.startsWith("/de/")) return true;
    if (search.includes("lang=de")) return true;

    // Cookie Weglot fréquent
    const c = getCookie("weglot_language");
    if (c) return c === "de";

    // fallback: <html lang="de">
    const langAttr = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return langAttr.startsWith("de");
  }

  function applySwap() {
    const imgs = getMainGalleryImages();
    if (!imgs.length) return;

    const german = isGerman();

    imgs.forEach((img, index) => {
      // Sauvegarde l’original une seule fois
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.currentSrc || img.src;
        img.dataset.originalSrcset = img.getAttribute("srcset") || "";
      }

      const deUrl = DE_IMAGES[index]; // index 0 = 1ère image, index 1 = 2e image, etc.

      if (german && deUrl) {
        img.src = deUrl;
        img.removeAttribute("srcset"); // important sinon Shopify peut choisir une autre variante
      } else {
        img.src = img.dataset.originalSrc;
        if (img.dataset.originalSrcset) img.setAttribute("srcset", img.dataset.originalSrcset);
      }
    });
  }

  function hookWeglot() {
    if (window.Weglot && typeof window.Weglot.on === "function") {
      window.Weglot.on("languageChanged", applySwap);
      return true;
    }
    return false;
  }

  document.addEventListener("DOMContentLoaded", function () {
    applySwap();

    // Weglot peut charger après → on retente quelques fois
    let tries = 0;
    const t = setInterval(() => {
      applySwap();
      if (hookWeglot() || tries++ > 30) clearInterval(t);
    }, 300);
  });

  document.addEventListener("shopify:section:load", applySwap);
})();
function swapHomeImage() {
  // Détection langue allemande (robuste)
  const isDE =
    (window.Weglot && (
      (typeof window.Weglot.getCurrentLang === "function" && window.Weglot.getCurrentLang() === "de") ||
      window.Weglot.currentLang === "de"
    )) ||
    document.documentElement.lang.startsWith("de") ||
    document.documentElement.getAttribute("data-wg-translated") === "de" ||
    location.pathname.startsWith("/de");

  if (!isDE) return;

  // 👉 On cible L'IMAGE HOME via son URL FR (celle que tu as dans la capture)
  const homeImg = document.querySelector(
    'img[src*="4a1493d3-ed0e-4fa5-9da5-5151f269e3b0"]'
  );

  if (!homeImg) return;

  // 👉 URL de TON image allemande (Contenu > Fichiers)
  homeImg.src = "https://cdn.shopify.com/s/files/1/0976/7433/0461/files/Creatives_statiques_-_Champife_1.png?v=1767706846";
  homeImg.removeAttribute("srcset");
}

// Au chargement
document.addEventListener("DOMContentLoaded", swapHomeImage);

// Quand Weglot change de langue sans reload
if (window.Weglot && typeof window.Weglot.on === "function") {
  window.Weglot.on("languageChanged", swapHomeImage);
}
